// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "bbc7e4ff7134e993f18b05b4df90dd5009b29ce1/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};